import { useEffect } from 'react';
import useUrlFilters from '../../hooks/useUrlFilters';

export const resolveAllowedTabKey = (tabs = [], storedTab) => {
    const requestedTab = Array.isArray(storedTab) ? storedTab[0] : storedTab;
    return tabs.some(tab => tab.key === requestedTab) ? requestedTab : tabs[0]?.key;
};

export default function useCommissionTabs(tabs) {
    const { query, handleFilterChange } = useUrlFilters({ mode: 'replace' });
    const activeTabKey = resolveAllowedTabKey(tabs, query.tab);

    useEffect(() => {
        if (activeTabKey && query.tab !== activeTabKey) {
            handleFilterChange('tab', activeTabKey);
        }
    }, [activeTabKey, handleFilterChange, query.tab]);

    return {
        activeTabKey,
        onTabChange: key => handleFilterChange('tab', key),
    };
}
